import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {APP_CONFIG} from '@synthroneApp/app.config';

import {MatDialog} from '@angular/material';
import {AlertComponent} from '@angular/synthrone-design/components';
import {ApiService, MessagesService} from '@angular/synthrone-design/services';

@Component({
    selector: 'app-components-view',
    templateUrl: './components-view.component.html',
    styleUrls: ['./components-view.component.scss']
})

export class ComponentsViewComponent implements OnInit {

    @ViewChild('sectionsTable') table;

    configColumns = {
        name: {
            label: 'Name',
            sortable: true,
            truncate: true
        },
        title: {
            label: 'Title',
            sortable: true,
            truncate: true
        },
        type: {
            label: 'Type',
            sortable: true,
            truncate: true
        },
        version: {
            label: 'Version',
            sortable: true,
            truncate: true
        }
    };

    queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    timeout = null;
    sortBy = 'id';
    sortOrder = 'asc';
    tableFilter = {
        'search': ''
    };
    requestTypeKey = 'componentType';
    responseTypeKey = 'type';

    constructor(private _router: Router, private route: ActivatedRoute, protected api: ApiService, @Inject(APP_CONFIG) private config, protected dialog: MatDialog, private messagesService: MessagesService) {
    }

    ngOnInit() {
        this.tableFilter = {
            'search': (typeof this.queryParams['search'] === "undefined") ? this.tableFilter.search : this.queryParams['search']
        }
    }

    setParams = () => {
        this.queryParams['search'] = this.tableFilter.search;
    }

    refreshTable = () => {
        this.table.getData()
    }

    add = () => {
        this._router.navigate(['/components/add']);
    };

    editRow = (key) => {
        this._router.navigate(['/components/edit', key]);
    };

    editVariantsRow = (key) => {
        this._router.navigate(['/components/edit', key, 'variants']);
    };

    deleteRow = (key) => {
        let dialogRef = this.dialog.open(AlertComponent, {
            data: {
                message: 'Are you sure that you want to delete this component?'
            }
        }).afterClosed().subscribe(result => {
            if (result == 'proceed') {
                this.api.makeRequest('api_system_component_delete', {
                    id: key
                }, 'crafter').subscribe(
                    (result) => {
                        if (this._router.url === '/components') {
                            this.table.getData();
                        } else {
                            this._router.navigate(['/components']);
                        }
                    },
                    (error) => {
                        this.messagesService.showSnack(error, 'error');
                    }
                );
            }
        });
    };

    changeTypeKey = (key) => {
        if(key == this.responseTypeKey) {
            key = this.requestTypeKey;
        }
        return key;
    }

    getTableData = (limit, offset, sortBy, sortOrder): Observable<any> => {
        return this.api.makeRequest('api_system_component_list', {
            seed: new Date().getTime(),
            offset: offset,
            limit: limit,
            sortBy: this.changeTypeKey(sortBy),
            sortOrder: sortOrder,
            filterValue: this.tableFilter.search
        }, 'crafter');
    }

    searchProductFN = () => {
     
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.setParams();
          this._router.navigate(['/components/1/10/'], { relativeTo: this.route, queryParams: this.queryParams });
          this.refreshTable();
        }, 2000);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/views/components-view/components-view.component.ts